(function(){
  var STORAGE_KEY = 'ns_shopify_checklist_v1';

  var phases = [
    {
      title:"Phase 1 — Unit Testing", role:"Developer-led",
      desc:"Validate individual fields and mappings in isolation. If these fail, nothing downstream will work. Do not move to Phase 2 until all items pass.",
      items:[
        {label:"SKU from Shopify matches NetSuite item ID exactly (case-sensitive)", tags:["inv"]},
        {label:"Shopify Order ID maps to custbody_shopify_order_id in NetSuite", tags:["order"]},
        {label:"Order date arrives in NetSuite in YYYY-MM-DD format", tags:["order"]},
        {label:"Currency on order matches the NetSuite subsidiary currency", tags:["order"]},
        {label:"Each payment gateway maps to a valid NetSuite payment method", tags:["order"]},
        {label:"Customer email is normalized to lowercase before dedup matching", tags:["cust"]},
        {label:"Tax line title maps to the correct NetSuite tax code (one-to-one)", tags:["tax"]},
        {label:"Tax-inclusive flag is handled correctly for UK/EU orders", tags:["tax"]},
        {label:"Each Shopify shipping method has a corresponding NetSuite service item", tags:["ship"]},
        {label:"Billing and shipping addresses map to separate NetSuite subrecords", tags:["ship"]}
      ],
      watchout:"A single space or case difference in a SKU will block the entire order from importing into NetSuite — silently in many connector setups. Run a full SKU audit before this phase."
    },
    {
      title:"Phase 2 — End-to-End Testing", role:"Developer + Ops",
      desc:"Test the full order lifecycle from placement to refund and cancellation. This is where most integration failures surface.",
      items:[
        {label:"Place a standard order in Shopify → Sales Order created correctly in NetSuite", tags:["order"]},
        {label:"All line items, quantities, and pricing carry across correctly", tags:["order"]},
        {label:"Discount code order → discount maps to correct NetSuite promo or discount line", tags:["order"]},
        {label:"Order with multiple currencies → correct currency and exchange rate in NetSuite", tags:["order"]},
        {label:"Fulfill the order in NetSuite → fulfillment status writes back to Shopify", tags:["ship"]},
        {label:"Tracking number from NetSuite triggers customer shipping notification in Shopify", tags:["ship"]},
        {label:"Inventory quantity in Shopify decrements correctly after order placement", tags:["inv"]},
        {label:"Refund in Shopify → Credit Memo created in NetSuite linked to original order", tags:["ref"]},
        {label:"Refund with restock → inventory adjustment applied in NetSuite", tags:["ref","inv"]},
        {label:"Refund with no restock → no inventory adjustment fires", tags:["ref"]},
        {label:"Cancel an order in Shopify → NetSuite transaction is voided or closed", tags:["order"]},
        {label:"New customer in Shopify → customer created in NetSuite without duplicates", tags:["cust"]}
      ],
      watchout:"Test refunds both with and without restocking, and test cancellations separately from refunds — they follow different paths in NetSuite."
    },
    {
      title:"Phase 3 — Edge Cases", role:"Developer + Ops",
      desc:"The phase most integrations skip — and regret. These are the exact scenarios that break silently in production.",
      items:[
        {label:"Guest checkout order handled via defined rule — no duplicate NetSuite records created", tags:["cust"]},
        {label:"Gift card order → gift card line handled without breaking order totals", tags:["order"]},
        {label:"Bundle product order → component SKUs resolve correctly in NetSuite", tags:["inv"]},
        {label:"POS order (if applicable) → syncs with correct order source tag", tags:["order"]},
        {label:"Tax-exempt customer → istaxable:false carries through to every order for that customer", tags:["tax","cust"]},
        {label:"AvaTax rounding discrepancy handled — Shopify tax passed as override, NS recalculation disabled", tags:["tax"]},
        {label:"Refund issued before original order has imported to NS → retry queue handles correctly", tags:["ref"]},
        {label:"Flash sale / high-volume scenario → inventory does not oversell during sync interval", tags:["inv"]},
        {label:"Lot-tracked or serialized item → additional sync logic fires correctly", tags:["inv"]},
        {label:"Product deactivated in NetSuite → listing unpublished in Shopify", tags:["inv"]},
        {label:"Duplicate order submission → external ID prevents duplicate NetSuite transaction", tags:["order"]},
        {label:"Tracking writeback failure → alert fires and retry queue activates", tags:["ship"]}
      ],
      watchout:"Edge cases by definition are infrequent — but when they occur in production with no handling logic, they create financial discrepancies that are very hard to unwind."
    },
    {
      title:"Phase 4 — UAT (User Acceptance Testing)", role:"Merchant-led",
      desc:"The team who will actually use NetSuite signs off. The developer should not be the one deciding this looks good.",
      items:[
        {label:"Finance: sample of imported orders verified against original Shopify records", tags:["owner:Finance","order"]},
        {label:"Finance: Credit Memos match refunded Shopify transactions", tags:["owner:Finance","ref"]},
        {label:"Finance: tax totals validated — no rounding drift on sample orders", tags:["owner:Finance","tax"]},
        {label:"Ops: inventory levels in Shopify match NetSuite after a full test order cycle", tags:["owner:Ops","inv"]},
        {label:"Ops: monitoring and alerting is live and confirmed working (failed sync notifications)", tags:["owner:Ops"]},
        {label:"Customer service: Shopify order reference locatable in NetSuite without friction", tags:["owner:CS","order"]},
        {label:"Fulfillment: tracking writeback confirmed end-to-end with a real test shipment", tags:["owner:Fulfillment","ship"]},
        {label:"All team members have correct NetSuite user roles and permissions", tags:["owner:All"]},
        {label:"Rollback or pause procedure is documented and understood by the team", tags:["owner:All"]},
        {label:"Go / No-Go sign-off obtained from each department lead", tags:["owner:All"]}
      ],
      watchout:"UAT is not a formality. If the finance or ops team finds an issue here, it will cost far less to fix than if they find it in production."
    },
    {
      title:"Phase 5 — Post-Release Monitoring", role:"Ongoing — Ops + Dev",
      desc:"Integration is not a one-off procedure. Work continues as normal, but an eye is kept on all synced data. This phase never fully closes.",
      items:[
        {label:"Daily: review sync error logs — no unhandled failures in the past 24 hours", tags:["all"]},
        {label:"Daily: confirm NetSuite inventory levels match Shopify for top 20 SKUs", tags:["inv"]},
        {label:"Weekly: spot-check 10 orders — NetSuite records match Shopify originals", tags:["order"]},
        {label:"Weekly: verify all refunds from the past 7 days have matching Credit Memos in NetSuite", tags:["ref"]},
        {label:"Weekly: tracking writeback success rate reviewed — no silent failures", tags:["ship"]},
        {label:"Monthly: full reconciliation of NetSuite financial records vs Shopify payouts", tags:["order","ref"]},
        {label:"Monthly: review any new Shopify features or updates for integration impact", tags:["all"]},
        {label:"On any platform update: re-run Phase 2 end-to-end tests before update goes live", tags:["all"]}
      ],
      watchout:"The most common post-release failure mode is a platform update (Shopify or NetSuite) that quietly breaks a field mapping. Build a lightweight re-test routine into your update process."
    }
  ];

  var tagClass = {
    order:'testing-checklist-tag-order',
    inv:'testing-checklist-tag-inv',
    cust:'testing-checklist-tag-cust',
    ref:'testing-checklist-tag-ref',
    tax:'testing-checklist-tag-tax',
    ship:'testing-checklist-tag-ship',
    all:'testing-checklist-tag-all'
  };
  var tagLabel = {order:'Orders',inv:'Inventory',cust:'Customers',ref:'Refunds',tax:'Tax',ship:'Shipping',all:'All areas'};
  var state = {};

  function loadState(){ try{ state = JSON.parse(localStorage.getItem(STORAGE_KEY)||'{}'); }catch(e){ state={}; } }
  function saveState(){ try{ localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); }catch(e){} }
  function itemKey(p,i){ return 'p'+p+'_i'+i; }

  function buildTabs(){
    var container = document.getElementById('tabs');
    phases.forEach(function(ph, pi){
      var tab = document.createElement('div');
      tab.className = 'testing-checklist-tab' + (pi===0?' testing-checklist-active':'');
      tab.id = 'tab-'+pi;
      tab.innerHTML = 'Phase '+(pi+1)+' <span class="testing-checklist-badge" id="badge-'+pi+'">0/'+ph.items.length+'</span>';
      tab.addEventListener('click', function(){ switchTab(pi); });
      container.appendChild(tab);
    });
  }

  function renderPanels(){
    var container = document.getElementById('panels');
    container.innerHTML = '';
    phases.forEach(function(ph, pi){
      var panel = document.createElement('div');
      panel.className = 'testing-checklist-panel'+(pi===0?' testing-checklist-active':'');
      panel.id = 'panel-'+pi;

      var done = ph.items.filter(function(_,ii){ return state[itemKey(pi,ii)]; }).length;
      var pct = ph.items.length ? Math.round(done/ph.items.length*100) : 0;

      var html =
        '<div class="testing-checklist-card">' +
          '<div class="testing-checklist-card-header">' +
            '<h3>'+ph.title+' <span style="font-weight:400;color:#888;font-size:0.85rem;">— '+ph.role+'</span></h3>' +
            '<p>'+ph.desc+'</p>' +
          '</div>' +
          '<div class="testing-checklist-phase-progress">' +
            '<div class="testing-checklist-phase-bar-bg"><div class="testing-checklist-phase-bar-fill" style="width:'+pct+'%"></div></div>' +
            '<span class="testing-checklist-phase-count">'+done+'/'+ph.items.length+' complete</span>' +
          '</div>';

      ph.items.forEach(function(item, ii){
        var checked = !!state[itemKey(pi,ii)];
        var tagHtml = item.tags.map(function(t){
          if(t.indexOf('owner:')===0) return '<span class="testing-checklist-tag testing-checklist-tag-owner">&#x1f464; '+t.replace('owner:','')+'</span>';
          return '<span class="testing-checklist-tag '+(tagClass[t]||'testing-checklist-tag-all')+'">'+(tagLabel[t]||t)+'</span>';
        }).join('');

        html +=
          '<div class="testing-checklist-item'+(checked?' testing-checklist-checked':'')+'" id="item-'+pi+'-'+ii+'">' +
            '<div class="testing-checklist-cb"><span class="testing-checklist-checkmark">✓</span></div>' +
            '<div class="testing-checklist-item-text">' +
              '<div class="testing-checklist-item-label">'+(ii+1)+'. '+item.label+'</div>' +
              '<div class="testing-checklist-item-meta">'+tagHtml+'</div>' +
            '</div>' +
          '</div>';
      });

      html +=
        '</div>' +
        '<div class="testing-checklist-watchout"><strong>&#x26a0; Watch Out</strong><p>'+ph.watchout+'</p></div>';

      panel.innerHTML = html;

      ph.items.forEach(function(_, ii){
        var el = panel.querySelector('#item-'+pi+'-'+ii);
        el.addEventListener('click', function(){ toggle(pi, ii); });
      });

      container.appendChild(panel);
    });

    updateProgress();
  }

  function toggle(pi, ii){
    var key = itemKey(pi,ii);
    state[key] = !state[key];
    saveState();
    var el = document.getElementById('item-'+pi+'-'+ii);
    el.classList.toggle('testing-checklist-checked', state[key]);
    updateProgress();
    updatePhaseBar(pi);
  }

  function updatePhaseBar(pi){
    var ph = phases[pi];
    var done = ph.items.filter(function(_,ii){ return state[itemKey(pi,ii)]; }).length;
    var pct = ph.items.length ? Math.round(done/ph.items.length*100) : 0;

    var panel = document.getElementById('panel-'+pi);
    if(panel){
      var bar = panel.querySelector('.testing-checklist-phase-bar-fill');
      var count = panel.querySelector('.testing-checklist-phase-count');
      if(bar) bar.style.width = pct+'%';
      if(count) count.textContent = done+'/'+ph.items.length+' complete';
    }

    var badge = document.getElementById('badge-'+pi);
    if(badge) badge.textContent = done+'/'+ph.items.length;
  }

  function updateProgress(){
    var total=0, done=0;
    phases.forEach(function(ph,pi){
      ph.items.forEach(function(_,ii){ total++; if(state[itemKey(pi,ii)]) done++; });
      var d = ph.items.filter(function(_,ii){ return state[itemKey(pi,ii)]; }).length;
      var badge = document.getElementById('badge-'+pi);
      if(badge) badge.textContent = d+'/'+ph.items.length;
    });

    var pct = total ? Math.round(done/total*100) : 0;
    document.getElementById('overall-bar').style.width = pct+'%';
    document.getElementById('overall-label').textContent = done+' / '+total+' items';
  }

  function switchTab(idx){
    document.querySelectorAll('.testing-checklist-tab').forEach(function(t,i){
      t.classList.toggle('testing-checklist-active', i===idx);
    });
    document.querySelectorAll('.testing-checklist-panel').forEach(function(p,i){
      p.classList.toggle('testing-checklist-active', i===idx);
    });
  }

  function exportCSV(){
    var csv = 'Phase,#,Item,Area,Status\n';
    phases.forEach(function(ph,pi){
      ph.items.forEach(function(item,ii){
        var status = state[itemKey(pi,ii)] ? 'Complete' : 'Pending';
        var area = item.tags.filter(function(t){ return t.indexOf('owner:')<0; })
          .map(function(t){ return tagLabel[t]||t; }).join(', ');
        csv += '"'+ph.title+'",+'+(ii+1)+',"'+item.label+'","'+area+'","'+status+'"\n';
      });
    });

    var blob = new Blob([csv],{type:'text/csv'});
    var a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'netsuite-shopify-testing-checklist.csv';
    a.click();
    showToast('Checklist exported as CSV ✓');
  }

  function resetAll(){
    if(!confirm('Reset all progress? This cannot be undone.')) return;
    state = {};
    saveState();
    renderPanels();
    showToast('Progress reset');
  }

  function showToast(msg){
    var t = document.getElementById('toast');
    t.textContent = msg;
    t.classList.add('testing-checklist-show');
    setTimeout(function(){ t.classList.remove('testing-checklist-show'); }, 3000);
  }

  // init
  loadState();
  buildTabs();
  renderPanels();

  document.getElementById('btn-export').addEventListener('click', exportCSV);
  document.getElementById('btn-reset').addEventListener('click', resetAll);

})();
